
export default (props) => {
    return (<div id={props.id}>
        {props.children}
    </div>)
}

const hostDns = process.env.REACT_APP_DNS_HOST

if (!hostDns) {
    throw { message: 'REACT_APP_DNS_HOST was not found' }
}

const initState = {
    authApi: `https://${hostDns}/auth`,
    avApi: `https://${hostDns}/avapi`,
    membershipApi: `https://${hostDns}/membershipapi`,
    eventStoreApi: `https://${hostDns}/eventstore`
}

export const reducer = (state = initState, action) => {
    return state
}
